import Swal from "sweetalert2";

export const DeleteSweetAlert = ({
  title,
  icon1,
  title2,
  text,
  icon2,
  callApi,
  setOldData,
  callSuccessModal = true,
}) => {
  return Swal.fire({
    title: title,
    text: title2,
    icon: icon1,
    showCancelButton: true,
    confirmButtonColor: "#5D87FF",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes",
  }).then(async (result) => {
    if (result.isConfirmed) {
      await callApi();
      if (callSuccessModal) {
        Swal.fire({
          title: title2,
          text: text,
          icon: icon2,
        });
      }
      if (setOldData) {
        setOldData();
      }
    }
  });
};
